module.exports = new __parcel__URL__("apply_k_faq_closed_btn_ko.7c6eb56c.webp").toString();